// import React, { useState } from 'react';
// import emailjs from '@emailjs/browser';
// import '../styles/Home.css';

// const EMAILJS_SERVICE_ID  = 'service_no4n7g3';
// const EMAILJS_TEMPLATE_ID = 'template_ziifrvj';
// const EMAILJS_PUBLIC_KEY  = 'G_X1XutdISfcAuX1h';

// const products = [
//   { img: '/cl.png', link: '#' },
//   { img: '/ql.png', link: '#' },
//   { img: '/il.png', link: '#' },
// ];

// const services = [
//   {
//     icon: '🚚',
//     title: 'Manufacturing',
//     desc: 'Our modern automatic manufacturing plants are designed to maintain high production efficiency, consistent quality, and precise processing standards. Every batch is produced under strict supervision to ensure purity, stability, and dependable industrial performance.'
//   },
//   {
//     icon: '☁️',
//     title: 'Sourcing',
//     desc: 'We directly source quality Khair wood and natural raw materials from trusted farmers across the Konkan region. Our strong sourcing network helps maintain year-round raw material availability and supports responsible, sustainable procurement practices.'
//   },
//   {
//     icon: '🌐',
//     title: 'Research & Quality Focus',
//     desc: 'Continuous innovation and strict quality monitoring are at the heart of our operations. We focus on developing high-performance natural extracts with reliable tannin strength, uniform color, and excellent usability across multiple industries.'
//   },
//   {
//     icon: '🔄',
//     title: 'Global Supply & Trusted Partnerships',
//     desc: 'With strong domestic and international market presence, we are committed to timely delivery, professional service, and long-term customer relationships. Our products are trusted by leading manufacturers, exporters, and industrial buyers worldwide.'
//   },
// ];

// function Home() {
//   const [formData, setFormData] = useState({
//     name: '', email: '', phone: '', subject: '', message: ''
//   });
//   const [isSending, setIsSending] = useState(false);
//   const [statusMsg, setStatusMsg] = useState({ text: '', type: '' });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSending(true);
//     setStatusMsg({ text: '', type: '' });

//     const templateParams = {
//       name: formData.name,
//       email: formData.email,
//       phone: formData.phone,
//       subject: formData.subject,
//       message: formData.message,
//     };

//     try {
//       await emailjs.send(
//         EMAILJS_SERVICE_ID,
//         EMAILJS_TEMPLATE_ID,
//         templateParams,
//         EMAILJS_PUBLIC_KEY
//       );
//       setStatusMsg({
//         text: '✅ Message sent successfully! We will contact you soon.',
//         type: 'success'
//       });
//       setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
//     } catch (error) {
//       console.error('EmailJS Error:', error);
//       setStatusMsg({
//         text: '❌ Failed to send message. Please try again.',
//         type: 'error'
//       });
//     } finally {
//       setIsSending(false);
//     }
//   };

//   return (
    
//     <div className="home-container">

//       {/* LEFT SIDE */}
//       <div className="home-left">

//         {/* Welcome Title */}
//         <div className="section-title-wrapper">
//           <span className="title-line"></span>
//           <h2 className="section-title1">Welcome To Sachin Kath Industries</h2>
//           <span className="title-line"></span>
          
//         </div>

//         <p className="welcome-text">
//           A trusted manufacturer and exporter of premium natural tannins and plant-based extracts,
//           delivering quality, purity, and consistency to industries across India and global markets.
//           With advanced manufacturing facilities, sustainable sourcing practices, and years of expertise,
//           we provide reliable solutions for leather tanning, herbal, food, dyeing, and
//           industrial applications. We are committed to innovation, customer satisfaction, and eco-friendly
//           production processes that ensure superior product performance and long-term business value.
//         </p>

//         <h3 className="why-title1">Why Choose Sachin Kath Industries:</h3>

//         <div className="services-grid">
//           {services.map((item, index) => (
//             <div className="service-card" key={index}>
//               <div className="service-top1">
//                 <h4>{item.title}</h4>
//                 <span className="service-icon">{item.icon}</span>
//               </div>
//               <p>{item.desc}</p>
//             </div>
//           ))}
//         </div>

//       </div>

//       {/* RIGHT SIDE */}
//       <div className="home-right">

//         <div className="sidebar-section">

//           {/* Hear From Us Title */}
//           <div className="section-title-wrapper">
//             <span className="title-line"></span>
//             <h3 className="section-title1">Get Quick Answers, Contact Us</h3>
//             <span className="title-line"></span>
//           </div>

//           <div className="call-box">
//             <img src="/sklogo.png" alt="Sachin Kath Industries" />
//             <div>
//               <p>Call Us To Get Started:</p>
//               <strong>+91-9665621383</strong>
//             </div>
//           </div>

//           <form className="contact-form" onSubmit={handleSubmit}>
//             <div>
//               <p className="form-label">Your Name (required)</p>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="Your Name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div>
//               <p className="form-label">Your Email (required)</p>
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Your Email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div>
//               <p className="form-label">Your Phone (required)</p>
//               <input
//                 type="tel"
//                 name="phone"
//                 placeholder="Your Phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//             <div>
//               <p className="form-label">Subject</p>
//               <input
//                 type="text"
//                 name="subject"
//                 placeholder="Enter Subject"
//                 value={formData.subject}
//                 onChange={handleChange}
//               />
//             </div>
//             <div>
//               <p className="form-label">Your Message</p>
//               <textarea
//                 name="message"
//                 placeholder="Enter Your Message"
//                 rows="5"
//                 value={formData.message}
//                 onChange={handleChange}
//               ></textarea>
//             </div>

//             {statusMsg.text && (
//               <p className={`home-status-msg ${statusMsg.type}`}>
//                 {statusMsg.text}
//               </p>
//             )}

//             <button type="submit" disabled={isSending}>
//               {isSending ? 'Sending...' : 'Send'}
//             </button>
//           </form>
//         </div>

//       </div>
//     </div>
//   );
// }

// export default Home;

import React, { useState } from 'react';
import '../styles/Home.css';

const WEB3FORMS_KEY = '2b0bfa96-2657-4cf8-9c78-d61543688285';

const products = [
  { img: '/cl.png', link: '#' },
  { img: '/ql.png', link: '#' },
  { img: '/il.png', link: '#' },
];

const services = [
  {
    icon: '🚚',
    title: 'Manufacturing',
    desc: 'Our modern automatic manufacturing plants are designed to maintain high production efficiency, consistent quality, and precise processing standards. Every batch is produced under strict supervision to ensure purity, stability, and dependable industrial performance.'
  },
  {
    icon: '☁️',
    title: 'Sourcing',
    desc: 'We directly source quality Khair wood and natural raw materials from trusted farmers across the Konkan region. Our strong sourcing network helps maintain year-round raw material availability and supports responsible, sustainable procurement practices.'
  },
  {
    icon: '🌐',
    title: 'Research & Quality Focus',
    desc: 'Continuous innovation and strict quality monitoring are at the heart of our operations. We focus on developing high-performance natural extracts with reliable tannin strength, uniform color, and excellent usability across multiple industries.'
  },
  {
    icon: '🔄',
    title: 'Global Supply & Trusted Partnerships',
    desc: 'With strong domestic and international market presence, we are committed to timely delivery, professional service, and long-term customer relationships. Our products are trusted by leading manufacturers, exporters, and industrial buyers worldwide.'
  },
];

function Home() {
  const [formData, setFormData] = useState({
    name: '', email: '', phone: '', subject: '', message: ''
  });
  const [isSending, setIsSending] = useState(false);
  const [statusMsg, setStatusMsg] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    setStatusMsg({ text: '', type: '' });

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          name:    formData.name,
          email:   formData.email,
          phone:   formData.phone,
          subject: `New Enquiry: ${formData.subject}`,
          message: formData.message,
        }),
      });

      const result = await response.json();
      console.log('Web3Forms result:', result);

      if (result.success) {
        setStatusMsg({
          text: '✅ Message sent successfully! We will contact you soon.',
          type: 'success'
        });
        setFormData({ name: '', email: '', phone: '', subject: '', message: '' });
      } else {
        console.error('Web3Forms error:', result);
        setStatusMsg({
          text: result.message || '❌ Failed to send. Please try again.',
          type: 'error'
        });
      }
    } catch (error) {
      console.error('Fetch error:', error);
      setStatusMsg({
        text: '❌ Network error. Please check internet and try again.',
        type: 'error'
      });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="home-container">

      {/* LEFT SIDE */}
      <div className="home-left">

        <div className="section-title-wrapper">
          <span className="title-line"></span>
          <h2 className="section-title1">Welcome To Sachin Kath Industries</h2>
          <span className="title-line"></span>
        </div>

        <p className="welcome-text">
          A trusted manufacturer and exporter of premium natural tannins and plant-based extracts,
          delivering quality, purity, and consistency to industries across India and global markets.
          With advanced manufacturing facilities, sustainable sourcing practices, and years of expertise,
          we provide reliable solutions for leather tanning, herbal, food, dyeing, and
          industrial applications. We are committed to innovation, customer satisfaction, and eco-friendly
          production processes that ensure superior product performance and long-term business value.
        </p>

        <h3 className="why-title1">Why Choose Sachin Kath Industries:</h3>

        <div className="services-grid">
          {services.map((item, index) => (
            <div className="service-card" key={index}>
              <div className="service-top1">
                <h4>{item.title}</h4>
                <span className="service-icon">{item.icon}</span>
              </div>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

      </div>

      {/* RIGHT SIDE */}
      <div className="home-right">
        <div className="sidebar-section">

          <div className="section-title-wrapper">
            <span className="title-line"></span>
            <h3 className="section-title1">Get Quick Answers, Contact Us</h3>
            <span className="title-line"></span>
          </div>

          <div className="call-box">
            <img src="/sklogo.png" alt="Sachin Kath Industries" />
            <div>
              <p>Call Us To Get Started:</p>
              <strong>+91-9665621383</strong>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div>
              <p className="form-label">Your Name (required)</p>
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <p className="form-label">Your Email (required)</p>
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <p className="form-label">Your Phone (required)</p>
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <p className="form-label">Subject</p>
              <input
                type="text"
                name="subject"
                placeholder="Enter Subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </div>
            <div>
              <p className="form-label">Your Message</p>
              <textarea
                name="message"
                placeholder="Enter Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>

            {statusMsg.text && (
              <p className={`home-status-msg ${statusMsg.type}`}>
                {statusMsg.text}
              </p>
            )}

            <button type="submit" disabled={isSending}>
              {isSending ? 'Sending...' : 'Send'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Home;